import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap, tap } from 'rxjs/operators';
import { of } from 'rxjs';
import { TagsService } from '../services/tags.services';
import * as TagsActions from './tags.actions';
import { TranslateService } from '@ngx-translate/core';
import { ToastService } from '../../shared/services/toast.service';
import { connectionsActions } from '../../connections/store/connections.actions';
import { Store } from '@ngrx/store';

@Injectable()
export class TagsEffects {
  private store = inject(Store);

  constructor(private actions$: Actions,
      private tagsService: TagsService,
      private toastService: ToastService,
      private translate: TranslateService) {}

  createTagsEffect$ = createEffect(() => this.actions$.pipe(
    ofType(TagsActions.createTag),
    switchMap((action) =>
      this.tagsService.createTag(action.tag).pipe(
        map(tag => {
          this.toastService.Success(this.translate.instant("tag.created"), '');
          return TagsActions.createTagSuccess({tag})
        }),
        catchError(() => of(TagsActions.createTagFailure({ error: 'Invalid credentials' })))
      )
    )
  ));

  getTagsEffect$ = createEffect(() => this.actions$.pipe(
    ofType(TagsActions.getTags),
    switchMap(() =>
      this.tagsService.getTags().pipe(
        map(tags => TagsActions.getTagsSuccess({tags}))
      )
    )
  ));

  editTagEffect$ = createEffect(() => this.actions$.pipe(
      ofType(TagsActions.editTag),
      switchMap((action) =>
        this.tagsService.editTag(action.tag).pipe(
          map(tag => {
            this.toastService.Success(this.translate.instant("tag.updated"), '');
            this.store.dispatch(connectionsActions.getConnections());
            return TagsActions.editTagSuccess({tag});
          }),
          catchError(() => of(TagsActions.deleteTagFailure({ error: 'Error cancelling tag' })))
        )
      )
    )
  );

  deleteTagEffect$ = createEffect(() => this.actions$.pipe(
      ofType(TagsActions.deleteTag),
      switchMap((action) =>
        this.tagsService.deleteTag(action.tagId).pipe(
          map(tag => {
            this.toastService.Success(this.translate.instant("tag.deleted"), '');
            this.store.dispatch(connectionsActions.getConnections());
            return TagsActions.deleteTagSuccess({tag});
          }),
          catchError(() => of(TagsActions.deleteTagFailure({ error: 'Error cancelling tag' })))
        )
      )
    )
  );
}
